import React, { useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import NotificationList from "src/components/NotificationsComponent/NotificationList";
import { onError, onSuccess } from 'src/store/actions/popupActions';
import axios from '../../../axios/AxiosInterceptors';
import useStyles from "../../../Styles";

const InternalBilateralNotificationList = (props) => {

    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const [recipients, setRecipients] = useState({});

    const retrieveNotificationList = async (pageNumber, pageSize, orderBy, direction) => {
        let urlParams = { pageSize: pageSize, pageNumber: pageNumber, orderBy: orderBy, direction: direction };
        await trackPromise(axios.get("/inschedule/v1/account/" + params.accountId + "/notification", { params: { ...urlParams } }).then(response => {
            if (response.data) {
                let recipients = response.data;
                if (recipients.results.length === 0) {
                    recipients.results.push({ accountId: params.accountId, name: '', emailAddress: '', sendNewInscheduleSchedules: false });
                }
                setRecipients({ ...recipients });
            }
        })).catch(error => {
            dispatch(onError(error.response));
        })
    }

    const saveRecipients = async (recipients) => {
        await trackPromise(axios.post("/inschedule/v1/account/" + params.accountId + "/notification", JSON.stringify(recipients)).then(response => {
            if (response.data) {
                let recipients = response.data;
                if (recipients.results.length === 0) {
                    recipients.results.push({ accountId: params.accountId, name: '', emailAddress: '', sendNewInscheduleSchedules: false });
                }
                setRecipients({ ...recipients });
            }
            dispatch(onSuccess("Successfully updated recipients"));
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const deleteRecipients = async (deletedRecipients) => {
        await trackPromise(axios.delete("/inschedule/v1/account/" + params.accountId + "/notification", { data: JSON.stringify(deletedRecipients) })).catch(error => {
            dispatch(onError(error.response));
        });
    }

    return (
        <main className={classes.layout}>
            <NotificationList notificationItems={[{ fieldName: "sendNewInscheduleSchedules", tableLabel: "New Schedules" }]}
                recipients={{ ...recipients }} retrieveDistributionList={retrieveNotificationList} deleteRecipients={deleteRecipients} saveRecipients={saveRecipients} />
        </main>
    )

}

export default InternalBilateralNotificationList;